module.exports = __webpack_public_path__ + "img/somerville_dog_fest.7737424f.jpg";